<template>
  <div>
    <LeftSidebar
      :visible="visible"
      :title="isParvandehList ? $lang.parvandehList : $lang.selectedParvandeh"
      bodyClass="padding-y-16 overflow-y-hidden"
      titleClass="padding-x-16"
      :hasBack="isParvandehList"
      :hasFooter="!isParvandehList"
      @back="handleCloseParvandehList"
      @close="handleClose"
    >
      <template>
        <ParvandehList v-if="isParvandehList" />
        <b-row v-else class="margin-0 padding-x-16">
          <b-col cols="12" class="padding-0 flex-between margin-bottom-8">
            <Button
              variant="primary"
              :text="$lang.newParvandeh"
              contentClass="justify-content-center"
              class="width-percent-100 margin-left-4"
              @click="handleOpenParvandehList"
            />
            <Button
              variant="outline-primary"
              :text="$lang.deleteAll"
              contentClass="justify-content-center"
              class="width-percent-100 margin-right-4"
              @click="deleteItems"
            />
          </b-col>
          <b-col
            v-for="(item, index) in items"
            :key="index"
            cols="12"
            class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8 flex-between"
          >
            <LazyImageBox
              :isImage="false"
              :fullName="item.fullName"
              :parvandehNumber="item.parvandehNumber"
              :firstCaption="item.termCaption"
              leftBoxClass="padding-left-12 max-width-266"
            />
            <span
              class="color-complementary-200 cursor--pointer"
              @click="removeItem(item.code)"
            >
              <mdicon name="trash-can-outline" size="24" />
            </span>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <Button
          variant="filled-complementary"
          :text="$lang.cancel"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleClose"
        />
        <Button
          variant="primary"
          :text="$lang.submit"
          class="mobile-width-percent-100 tablet-width-percent-100"
          contentClass="justify-content-center"
          @click="handleSubmit"
        />
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import LeftSidebar from "@/components/re-design/sidebar/LeftSidebar.vue";
import LazyImageBox from "@/components/re-design/lazy-image-box/LazyImageBox.vue";
import { Button } from "@/components/re-design/forms";
import ParvandehList from "./ParvandehList.vue";
import { ref, toRefs, watch } from "vue";

export default {
  components: { LeftSidebar, LazyImageBox, Button, ParvandehList },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible } = toRefs(props);

    const handleClose = () => emit("handleClose");

    const items = ref([]);
    const LOCAL_STORAGE_NAME = "dashboard-parvandeh-codes";
    const generateItems = () => {
      const localStorageData = localStorage.getItem(LOCAL_STORAGE_NAME);
      const parvandehCodes = JSON.parse(localStorageData) || [];
      items.value = Array.isArray(parvandehCodes) ? parvandehCodes : [];
    };
    const deleteItems = () => {
      items.value = [];
      localStorage.removeItem(LOCAL_STORAGE_NAME);
      generateItems();
    };
    const removeItem = (code) => {
      const index = items.value.findIndex((item) => item.code === code);
      if (index !== -1) {
        items.value.splice(index, 1);
        localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify(items.value));
      }
      generateItems();
    };

    watch(visible, (value) => {
      if (value) {
        generateItems();
      }
    });

    // handle parvandeh list
    const isParvandehList = ref(false);
    const handleOpenParvandehList = () => {
      isParvandehList.value = true;
    };
    const handleCloseParvandehList = () => {
      isParvandehList.value = false;
      generateItems();
    };

    const handleSubmit = () => {
      emit("handleSubmit");
      handleClose();
    };

    // return data to be used in template
    return {
      visible,
      handleClose,
      items,
      deleteItems,
      removeItem,
      isParvandehList,
      handleOpenParvandehList,
      handleCloseParvandehList,
      handleSubmit,
    };
  },
};
</script>
